export default __webpack_public_path__ + "static/media/NaharTime.a53c86d3.svg";